export default __webpack_public_path__ + "static/cryptokitties-8e76457738755b3765171ac226b430c9.png";